( function( app ) {
  const COMPONENT = {
    init: function() {
      cardContentPositioning();
      $( window ).on( 'resize', function() {
        cardContentPositioning();
      } );
      const displayOnHover = false;
      function cardContentPositioning() {
        if ( !displayOnHover ) return;

        if ( window.innerWidth > 1024 ) {
          $( '.image-column-cards__card-content' ).each( function() {
            const hoverContent = $( this ).find( '.image-column-cards__hover-content' );
            const descriptionHeight = hoverContent.outerHeight();

            $( this ).css( {
              'opacity': '1',
              'transform': `translateY(${descriptionHeight}px)`,
            } );

            // Force a reflow before adding the transition to prevent jumping on load
            // and don't add it if prefers reduced motion is true
            if ( window.hasMotion ) {
              requestAnimationFrame( () => {
                $( this ).css( 'transition-duration', '0.5s' );
              } );
            }
          } );
        } else {
          $( '.image-column-cards__card-content' ).each( function() {
            $( this ).css( {
              'opacity': '1',
              'transform': `translateY(0px)`,
            } );
          } );
        }
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'image-column-cards', COMPONENT );
} )( app );
